export default (symbol) => {
  let tick_size;
  let tick_profit;

  switch (symbol) {
    case "WINFUT":
      tick_size = 5;
      tick_profit = 1;
      break;
    case "WDOFUT":
      tick_size = 0.5;
      tick_profit = 5;
      break;
    case "INDFUT":
      tick_size = 5;
      tick_profit = 5;
      break;
    case "DOLFUT":
      tick_size = 0.5;
      tick_profit = 25;
      break;
    case "CCMFUT":
      tick_profit = 4.5;
      tick_size = 0.01;
      break;
    case "WSPFUT":
      tick_profit = 0.625;
      tick_size = 0.25;
      break;
    case "BITFUT":
      tick_profit = 2;
      tick_size = 20;
      break;
    default:
      tick_size = 0.01;
      tick_profit = 0.01;
      break;
  }
  return { tick_size, tick_profit };
};
